import { render, staticRenderFns } from "./UserFormDialog.vue?vue&type=template&id=35e5b5a2&"
import script from "./UserFormDialog.vue?vue&type=script&lang=js&"
export * from "./UserFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserFormDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports